import script from "./NotificationPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPopup.vue?vue&type=style&index=0&id=689effca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689effca"]])

export default __exports__